import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
    SprayApplicationRate,
    SprayProductPerUnitType,
    SprayProductUnits
} from 'services/sprayEvents/types';
import { ProductId } from 'services/products/types';
import { AppState } from 'services/types';
import { UnitTypeId } from 'services/unitTypes/types';
import { makeSelectRate } from './selectors';

interface ConnectedProps {
    rate?: string;
}

export interface OwnProps {
    applicationRate: SprayApplicationRate;
    units: SprayProductUnits;
    productId: ProductId;
    unitTypeId: UnitTypeId;
    perUnitType: SprayProductPerUnitType;
}

export type Props = OwnProps & ConnectedProps;

export class ProductRateFieldValueComponent extends React.PureComponent<Props> {
    render(): string | null {
        const { rate } = this.props;

        if (!rate) return null;

        return rate;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    rate: makeSelectRate()
});

export default connect(mapStateToProps)(ProductRateFieldValueComponent);
